import { render } from "./ContingentList.vue?vue&type=template&id=19cc21e3&scoped=true"
import script from "./ContingentList.vue?vue&type=script&lang=js"
export * from "./ContingentList.vue?vue&type=script&lang=js"

import "./ContingentList.vue?vue&type=style&index=0&id=19cc21e3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19cc21e3"]])

export default __exports__